/* eslint-disable no-undef */
class VideoNudge {
  constructor (el) {
    this.els = {
      el,
      productVideoNudge: document.querySelectorAll(
        '[data-product-video-nudge]'
      ),
      productVideoContainer: document.querySelector('.sec-VideoNudge_Video'),
      productVideoCloseButton: document.querySelector('.sec-VideoNudge_Close')
    }

    this.player = null
    this.loaded = false
    this.videoId = 'MOdJz_f776k' // Store video ID as a property

    this.setupListeners()
  }

  setupListeners = () => {
    if (localStorage.getItem('product_video_nudge') !== null) return

    this.els.productVideoNudge.forEach((el) => {
      el.classList.add('active')
      el.addEventListener('click', this.handleVideoNudgeClick)
    })

    this.els.productVideoCloseButton.addEventListener('click', this.closeVideo)
  }

  // Function to remove event listeners and hide elements
  cleanupVideoNudge = () => {
    if (!this.els.productVideoNudge) {
      console.error('this.els.productVideoNudge is undefined')
      return
    }

    this.els.productVideoNudge.forEach((el) => {
      el.removeEventListener('click', this.handleVideoNudgeClick) // Remove listener
      el.classList.remove('active') // Hide element
    })
  }

  // Named event handler to allow removal
  handleVideoNudgeClick = () => {
    localStorage.setItem('product_video_nudge', 'true')

    // Cleanup event listeners and hide elements
    this.cleanupVideoNudge()

    if (!this.loaded) {
      this.loadYouTubeAPI()
      this.checkYouTubeAPIReady()
    } else {
      this.playVideo()
    }
  }

  loadYouTubeAPI = () => {
    if (
      !document.querySelector(
        'script[src="https://www.youtube.com/iframe_api"]'
      )
    ) {
      const tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      const firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }
  }

  checkYouTubeAPIReady = () => {
    if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
      this.onYouTubeIframeAPIReady()
    } else {
      setTimeout(this.checkYouTubeAPIReady.bind(this), 100)
    }
  }

  onYouTubeIframeAPIReady = () => {
    if (this.els.productVideoContainer) {
      try {
        // Create a div for the player
        const playerDiv = document.createElement('div')
        playerDiv.id = 'nudge-video-player'
        this.els.productVideoContainer.appendChild(playerDiv)

        this.player = new YT.Player(playerDiv, {
          videoId: this.videoId,
          playerVars: {
            playsinline: 1,
            modestbranding: 1,
            origin: encodeURIComponent(window.location.origin),
            rel: 0,
            autoplay: 1
          },
          events: {
            onReady: this.onPlayerReady.bind(this),
            onError: this.onPlayerError.bind(this)
          }
        })
      } catch (error) {
        console.error('Error creating YouTube player:', error)
      }
    }
  }

  onPlayerReady = (event) => {
    this.loaded = true
    this.playVideo()
  }

  onPlayerError = (event) => {
    console.error('YouTube player error:', event.data)
  }

  playVideo = () => {
    this.els.productVideoContainer.style.display = 'flex'
    if (this.player && this.loaded) {
      this.player.playVideo()
    }
  }

  closeVideo = () => {
    if (this.player) {
      this.player.stopVideo()
    }
    this.els.productVideoContainer.remove()
  }
}

new VideoNudge()
